// extracted by mini-css-extract-plugin
export var card = "_jj-5";
export var cardSelected = "_jj-4";
export var image = "_jj-3";
export var modal = "_jj-0";
export var modalContent = "_jj-1";
export var table = "_jj-2";